<script lang="ts">
    import { Component, Prop, Vue } from "vue-facing-decorator";
    import { panelStateService, TicketSelectionApplicationData, useSeatmapStore } from "@/domain/ticket-selection";
    import { PriceListResponse } from "webshop-api";
    import { CurrencyHandler } from 'webshop-modules';

    @Component({})
    export default class PriceLevelFilter extends Vue {

        @Prop() readonly data!: TicketSelectionApplicationData;

        public readonly seatmapStore = useSeatmapStore();
        public readonly panelState = panelStateService;

        public CurrencyHandler!: CurrencyHandler;

        public get currency(): string {
            if (!this.data) {
                return '';
            }

            return this.priceList !== null
                ? this.priceList.currency!
                : this.data.configuration.cartCurrency !== null
                    ? this.data.configuration.cartCurrency
                    : this.data.configuration.poolCurrency;
        }

        public get priceList(): PriceListResponse | null {
            return this.data.priceList;
        }

        protected created(): void {
            this.CurrencyHandler = new CurrencyHandler(
                this.currency ?? '',
                this.data.currencyOptions?.currency ?? '',
                this.data.currencyOptions?.conversionRate ?? '1',
                this.data.currencyOptions?.showDoubleCurrency ?? false,
            );
        }

    }
</script>

<template>
    <div class="m-priceLevelFilter__container">
        <template v-for="item in seatmapStore.getPriceLevelFilter" :key="item">
            <div v-bind:class="{'-selected': panelState.actions.selectFilter?.id === item.id}"
                 class="m-priceLevelFilter__item"
                 v-on:click="panelState.updateFilter(item)">
                     <span class="m-priceLevelFilter__color"
                          :style="{ backgroundColor: item.color, color: item.textColor }"></span>
                <span class="m-priceLevelFilter__name">{{ item.name }}</span>
                <div>
                    <span>{{ CurrencyHandler.displayPrimaryCurrency(item.startPrice) }}</span>
                    <small v-if="CurrencyHandler.isSecondaryCurrencyDisplayed">
                        ({{ CurrencyHandler.displaySecondaryCurrency(item.startPrice) }}) +</small>
                    <span v-if="seatmapStore.fees.length > 0">*</span>
                </div>
            </div>
        </template>
    </div>
</template>